/**
    Настройки отображения каротажных кривых

    CurveDisplaySettings - настройки для отрисовки
    CurveSettings - настройки из бд
*/

interface MinMaxDepths {
    depthStart?: number;
    depthStop?: number;

    depthAbsStart?: number;
    depthAbsStop?: number;
}

interface MinMaxValues {
    xStart?: number;
    xStop?: number;
}
export enum MinMaxValueType {
    MinMax = 'minMax',
    Extremum = 'extremum',
}

export enum FillingType {
    Seam = 'seam',
    Value = 'value',
}
export enum FillingValueType {
    Greater = 'greater',
    Less = 'less',
}
export enum CurvesFillingType {
    None = 'none',
    Greater = 'greater',
    Less = 'less',
}

export interface ScaleProps {
    xStart?: number;
    xStep?: number;
    xStop?: number;
}
export interface ChildCurve {
    key: string;
    parentCurve: number;
    curve: number;
    xStart?: number;
    xStep?: number;
    xStop?: number;
}
export interface CurveDisplaySettings {
    // Зеркальное отображение кривой
    isMirroring: boolean;
    // Десятичный логарифм значений
    isDecimalLog: boolean;

    // Ограничение глубин кривой
    isChangeMinMaxDepths: boolean;
    minMaxValueType: MinMaxValueType;
    minMaxDepths: MinMaxDepths | null;

    // Изменение граничных точек
    isChangeMinMaxValues: boolean;
    minMaxValues: MinMaxValues | null;

    // Заливка области диаграммы
    isFilling: boolean;
    fillingType: FillingType;

    // Раздел с масштабами активен
    isScales: boolean;

    // Шаг кривой
    isCurveStep: boolean;
    maxStep: number;

    fillingValue: number;
    fillingValueType: FillingValueType;
    isFillingOutside: boolean;

    // Заливка между парой кривых
    isCurvesFilling: boolean;
    curvesFillingType: CurvesFillingType;
    curvesFillingColor: string;
    curvesFillingResearch: string | undefined;
    scaleProps: ScaleProps | null;
    childrenCurves: ChildCurve[] | null;
}
